import { routes as nestedRoutes } from './:userId'

export const routes = {
  ...nestedRoutes,
} as const
